<swiper-container
  appSwiperDirective
  init="false"
  [config]="configSliderEvent"
  class="slider-event overflow-visible"
>
  <swiper-slide *ngFor="let item of data">
    <div class="slide-event">
      <div class="slide-event__picture">
        <img
          [ngSrc]="'/assets/images/defense/' + item?.image"
          alt="Picture Event"
          height="630" width="1200"
        >
      </div>

      <div class="slide-event__wrapper">
        <div class="slide-event__info" data-swiper-parallax-x="-50" data-swiper-parallax-duration="500">
          <p>
            {{ item?.event }}
          </p>

          <small>
            {{ item?.date }}
          </small>
        </div>

        <div class="slide-event__main">
          <div class="slide-event__title" data-swiper-parallax-x="-50" data-swiper-parallax-duration="600">
            {{ item?.title }}
          </div>

          <div class="slide-event__description" data-swiper-parallax-x="-50" data-swiper-parallax-duration="700">
            {{ item?.description }}
          </div>

          <div class="slide-event__action" data-swiper-parallax-x="-50" data-swiper-parallax-duration="800">
            <a [href]="item?.link" class="btn btn--defense btn--small lg:min-w-[280px]" target="_blank">
              Дізнатися більше
            </a>
          </div>
        </div>
      </div>
    </div>
  </swiper-slide>

  <div class="slider-event__pagination" slot="container-end">
    <div class="swiper-event-pagination"></div>
  </div>
</swiper-container>
